import Super from './-base';
import classic from 'ember-classic-decorator';

@classic
export default class SignInTokenRequest extends Super {}
